// extracted by mini-css-extract-plugin
export default {"AuthForm":"style_AuthForm__ZvwmP"};